<template>
    <BaseDialog
        :showDialog="showNoSharesDialog"
        maxDialogWidth="900"
        maxCardHeight="900"
        headline="lang_PUBLISHING_WORKS_NOSHARES_DIALOG_HEADLINE"
        :close="closeDialog"
        persistent
        :alvqa="alvqa"
    >
        <template v-slot:dialogText>
            <v-container fluid >
                <v-row style="background-color: var(--v-listPageHeadlineBackground-base);">
                    <v-col 
                        class="headline"
                        :alvqa="alvqa + '-dialog-title'"
                    >
                        {{ $t('lang_PUBLISHING_WORKS_CAPTION_ORIGINAL_SHARES')}}
                    </v-col>
                </v-row>
                <v-container fluid class="py-6">
                    <v-row class="ml-4" v-if="getCurrentConfig.show.manu || getCurrentConfig.show.role">  
                        <v-col>
                                <BaseCheckbox 
                                    :context="context"
                                    :label="$t('lang_GENERAL_MANU_PERCENT')" 
                                    :valueOuter="'manu'"
                                    :disabled="!getCurrentConfig.show.manu"
                                    hideDetails
                                    class="mt-0"
                                    :alvqa="alvqa + '-checkbox-manu'"
                                />
                        </v-col>
                        <v-col cols="1"></v-col>
                        <v-col>
                            <BaseCheckbox 
                                    :context="context"
                                    :label="$t('lang_GENERAL_ROLE_PERCENT')" 
                                    :valueOuter="'role'"
                                    :disabled="!getCurrentConfig.show.role"
                                    hideDetails
                                    class="mt-0"
                                    :alvqa="alvqa + '-checkbox-role'"
                                />
                        </v-col>
                    </v-row>
                    <v-row class="ml-4" v-if="getCurrentConfig.show.intl || getCurrentConfig.show.own">
                        <v-col>
                            <BaseCheckbox 
                                    :context="context"
                                    :label="$t('lang_GENERAL_INTL_PERCENT')"
                                    valueOuter="intl"
                                    :disabled="!getCurrentConfig.show.intl"
                                    hideDetails
                                    class="mt-0"
                                    :alvqa="alvqa + '-checkbox-intl'"
                                />
                        </v-col>
                        <v-col cols="1" v-if="getCurrentConfig.show.intl"></v-col>
                        <v-col>
                            <BaseCheckbox 
                                    :context="context"
                                    :label="$t('lang_GENERAL_OWN_PERCENT')"
                                    valueOuter="own"
                                    :disabled="!getCurrentConfig.show.own"
                                    hideDetails
                                    class="mt-0"
                                    :alvqa="alvqa + '-checkbox-own'"
                                />
                        </v-col>
                    </v-row>
                </v-container>
                <v-container class="px-0" v-if="getCurrentConfig.show.homeSociety">
                    <v-row style="background-color: var(--v-listPageHeadlineBackground-base);">
                        <v-col 
                            class="headline"
                            :alvqa="alvqa + '-dialog-title'"
                        >
                            {{ $t('lang_GENERIC_CAPTION_DIRECT_MEMBERSHIP')}}
                        </v-col>
                    </v-row>
                    <v-container class="py-6">
                        <v-row class="ml-4">
                            <v-col>
                                <BaseCheckbox 
                                    :context="context + 'HomeSociety'"
                                    :label="homeSocietyName"
                                    :valueOuter="getHomeSocietyInfo"
                                    hideDetails
                                    class="mt-0"
                                    :alvqa="alvqa + '-checkbox-' + homeSocietyNameForAlvqa"
                                />
                            </v-col>
                            <template v-for="(society) in getDirectMembershipSocieties" >
                                <v-col cols="4" class="text-no-wrap">
                                    <BaseCheckbox 
                                        :key="society.societyCode"
                                        :context="context + 'HomeSociety'"
                                        :label="$alvPlugin.getSocietyPanelHeadline(society.societyCode)"
                                        :valueOuter="society.societyCode"
                                        hideDetails
                                        class="mt-0"
                                        :alvqa="alvqa + '-checkbox-' + society.societyCode"
                                        v-if="society.societyCode !== null"
                                    />
                                </v-col>
                            </template>
                        </v-row>
                    </v-container>
                </v-container>
            </v-container>
        </template>
    </BaseDialog>
</template>

<script>
import BaseDialog from '@/components/_base/BaseDialog'
import BaseButton from '@/components/_buttons/BaseButton'
import BaseCheckbox from '@/components/_base/BaseCheckbox'
import BaseEditPageDropdown from '@/components/_editForm/BaseEditPageDropdown'
import BaseRegions from '@/components/_base/BaseRegions'
import BaseIcon from '@/components/_buttons/BaseIcon'
import api from '@/api_alv.js'

export default {
    name: "NoSharesDialog",
    components: {
        BaseDialog,
        BaseButton,
        BaseCheckbox,
        BaseEditPageDropdown,
        BaseRegions,
        BaseIcon
    },
    data() {
        return {
            context: "NoShares",
            alvqa: 'publishing-works-list-dialog-no-shares',
            homeSocietyName: '',
            homeSocietyNameForAlvqa: '',
        }
    },
    computed: {
        getDirectMembershipSocieties() {
            let data = this.$store.getters.getAzSocietiesWhereDirectMember.filter((society) => society.societyCode !== this.getHomeSocietyInfo && society.societyCode !== null)
            return data
        },    
        showNoSharesDialog: {
            get() { return this.$store.getters.getShowNoSharesDialog },
            set(show) { this.$store.commit('setShowNoSharesDialog', show) }
        },
        sharePercentageOption: {
            get() { return this.$store.getters.getSelectedWorksQualityFilter },
            set(show) { this.$store.commit('setSelectedWorksQualityFilter', show) }
        },
        configByOption() {
            return {
                '100Share' : {
                    'show': {
                        'manu': false,
                        'role': false,
                        'intl': true,
                        'own': true,
                        'homeSociety': true
                    }
                },
                'lessThan100Share' : {
                    'show': {
                        'manu': false,
                        'role': false,
                        'intl': true,
                        'own': true,
                        'homeSociety': true
                    }
                },
                'noShare' : {
                    'show': {
                        'manu': true,
                        'role': true,
                        'intl': true,
                        'own': true,
                        'homeSociety': true
                    }
                },
                'noUVZ' : {
                    'show': {
                        'manu': false,
                        'role': true,
                        'intl': true,
                        'own': true,
                        'homeSociety': true
                    }
                },
                'withContractChains' : {
                    'show': {
                        'manu': false,
                        'role': true,
                        'intl': true,
                        'own': true,
                        'homeSociety': true
                    }
                },
                '0Share' : {
                    'show': {
                        'manu': false,
                        'role': true,
                        'intl': true,
                        'own': true,
                        'homeSociety': true
                    }
                },
                'noUvzOfContractingParty': {
                    'show': {
                        'manu': false,
                        'role': true,
                        'intl': true,
                        'own': true,
                        'homeSociety': true
                    }
                },
                'allDisabled': {
                    'show': {
                        'manu': false,
                        'role': false,
                        'intl': false,
                        'own': false,
                        'homeSociety': false
                    }
                }
            }
        },
        getCurrentConfig() {
            return this.sharePercentageOption && this.sharePercentageOption in this.configByOption ? 
                this.configByOption[this.sharePercentageOption] : this.configByOption['allDisabled']
        },
        getHomeSocietyInfo(){
            let userInformation = JSON.parse(localStorage.getItem("userData"))['user']
            let homeSocietyCode = userInformation.homeSocietyCode

            this.homeSocietyName =  this.$alvPlugin.getSocietyPanelHeadline(homeSocietyCode)
            this.homeSocietyNameForAlvqa = this.$alvPlugin.getSocietyName(parseInt(homeSocietyCode)).toLowerCase()
            
            return homeSocietyCode.toString()
        },
    },
    watch: {
        showNoSharesDialog(newVal) {
            if (newVal) {
                this.$store.dispatch('fetchAzSocietiesWhereDirectMember')
            }
        }
    },
    methods: {
        closeDialog() {
            if(this.$store.getters.getNoSharesCheckbox.length === 0 && this.$store.getters.getNoSharesHomeSocietyCheckbox.length === 0){
                this.$store.commit("setSelectedWorksQualityFilter",[])
                this.$store.commit('setSnackbar', {
                    type: 'error',
                    msg: this.$t('lang_PUBLISHING_WORKS_NOSHARES_FILTER_NO_OPTIONS_CHOOSEN')
                })
            }
            this.showNoSharesDialog = false
        },
        start() {
        },
    }
}
</script>
<style>
/** CHECK IF IT IS OK TO MOVE TO GENERAL CSS */
label.v-label--is-disabled.theme--light span {
    color: inherit!important;
}
</style>